import CalculateOutlined from "@mui/icons-material/CalculateOutlined";

import { makeSvgIcon } from "./svg-icon";

export const CalculateIcon = makeSvgIcon(CalculateOutlined);

export default CalculateIcon;
